import React from 'react';
import PropTypes from 'prop-types';

import withTheme from 'core/hocs/withTheme';

import themePropTypes from 'core/utils/prop-types/theme';


function Counter(props) {
  const {
    total,
    delimiter,
    currentIndex,
    theme: {
      controls: {
        counter: counterAtoms,
      },
    },
  } = props;

  return (
    <div className='counter'>
      <style jsx>{`
        .counter
          font ${counterAtoms.font}
          color ${counterAtoms.color}
      `}</style>
      {currentIndex + 1}{delimiter}{total}
    </div>
  );
}

Counter.propTypes = {
  /**
   * Общее количество элементов
   */
  total: PropTypes.number,
  /**
   * Индекс текущего элемента
   */
  currentIndex: PropTypes.number,
  /**
   * Разделитель между индексом и общим количеством
   */
  delimiter: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.node,
  ]),
  /** @ignore */
  theme: themePropTypes(`
    {
      controls: {
        counter: {
          font,
          color,
        },
      },
    }
  `),
};

Counter.defaultProps = {
  total: 0,
  currentIndex: 0,
  delimiter: ' / ',
};

const CounterWithHOCs = withTheme(Counter);
CounterWithHOCs.displayName = 'Counter';

export { Counter as StorybookComponent };
export default CounterWithHOCs;
